import { useMemo, useRef, useState } from "react";
import { PlayerRef } from "@remotion/player";
import PlayerOnly from "./Player-only";
import { useSelector } from "react-redux";
import { GetFps } from "../../Redux/Reducers/redux-slice-timetool";

export const ControlledSequence = ({ duration, ...props }: { duration }) => {
  const [title, setTitle] = useState("Hello World");
  const [color, setColor] = useState("#ffffff");
  const [bgColor, setBgColor] = useState("#000000");
  const [loop, setLoop] = useState(false);
  const [doubleClickToFullscreen, setDoubleClickToFullscreen] = useState(true);
  const [clickToPlay, setClickToPlay] = useState(true);
  const [spaceKeyToPlayOrPause, setSpaceKeyToPlayOrPause] = useState(true);
  const [moveToBeginningWhenEnded, setMoveToBeginningWhenEnded] = useState(true);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [showPosterWhenUnplayed, setshowPosterWhenUnplayed] = useState(false);
  const [showPosterWhenEnded, setShowPosterWhenEnded] = useState(false);
  const [showPosterWhenPaused, setShowPosterWhenPaused] = useState(false);
  const [inFrame, setInFrame] = useState<number | null>(null);
  const [outFrame, setOutFrame] = useState<number | null>(null);
  const [alwaysShowControls, setAlwaysShowControls] = useState(false);
  const [showVolumeControls, setShowVolumeControls] = useState(true);
  const [showPlaybackRateControl, setPlaybackRateControl] = useState(false);

  const [width, setWidth] = useState(16);
  const [height, setHeight] = useState(9);
  const fps = useSelector(GetFps);

  const ref = useRef<PlayerRef>(null);

  const inputProps = useMemo(() => {
    return {
      title: String(title),
      bgColor: String(bgColor),
      color: String(color),
    };
  }, [bgColor, color, title]);

  return (
    <>
      <PlayerOnly
        controls={false}
        alwaysShowControls={alwaysShowControls}
        clickToPlay={clickToPlay}
        doubleClickToFullscreen={doubleClickToFullscreen}
        durationInFrames={duration}
        inputProps={inputProps}
        loop={loop}
        moveToBeginningWhenEnded={moveToBeginningWhenEnded}
        playbackRate={playbackRate}
        spaceKeyToPlayOrPause={spaceKeyToPlayOrPause}
        playerRef={ref}
        showPosterWhenEnded={showPosterWhenEnded}
        showPosterWhenPaused={showPosterWhenPaused}
        showPosterWhenUnplayed={showPosterWhenUnplayed}
        showVolumeControls={showVolumeControls}
        showPlaybackRateControl={showPlaybackRateControl}
        inFrame={inFrame}
        outFrame={outFrame}
        width={width}
        height={height}
        fps={fps}
        context="sequence"
        {...props}
      />
    </>
  );
};
